import { useIsMutating } from "@tanstack/react-query";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";

import {
  applicantIncludeAppealCommentLogAction,
  applicantPasteEventAction,
} from "@actions/ApplicantAction";

import {
  examResultKeys,
  useFeatureFlags,
  useSendScreenshotApplicantAction,
  useSubmitApplicantsExamsResults,
} from "@shared/hooks/query";
import { withCustomHook } from "@shared/services/withCustomHook";

import EditorMain, {
  BaseProps,
  InjectedProps,
  PasteEventType,
} from "./EditorMain";

const wrapper = withCustomHook<BaseProps & InjectedProps>(
  ({ challengeId, exam }) => {
    const challengeResultId = exam.getResultByChallengeId(challengeId).id;
    const isSubmittingChallenge = Boolean(
      useIsMutating(examResultKeys.submit(challengeResultId)),
    );
    const submitChallenge = useSubmitApplicantsExamsResults(challengeResultId);
    const sendScreenshotEvent = useSendScreenshotApplicantAction({
      challengeResultId,
    });
    const { data } = useFeatureFlags();
    const isWebcamEnabled = data?.webcamEnabled ?? false;

    return {
      isSubmittingChallenge,
      submitChallenge,
      sendScreenshotEvent,
      isWebcamEnabled,
      hasVerifiedLiveness: exam.webcamStatus.hasVerifiedLiveness,
    };
  },
)(EditorMain);

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  applicantIncludeAppealCommentLogAction: (payload: {} = {}) => {
    dispatch(applicantIncludeAppealCommentLogAction.request(payload));
  },
  sendPasteEvent(payload: PasteEventType) {
    const params =
      "questionVersionId" in payload
        ? {
            questionVersionId: payload.questionVersionId,
            pastedText: payload.pastedText,
          }
        : { pastedText: payload.pastedText, filename: payload.filename };
    dispatch(
      applicantPasteEventAction.request(params, {
        resultId: payload.resultId,
      }),
    );
  },
});

/**
 * Wrapped component
 */
const wrappedComponent = connect(() => ({}), mapDispatchToProps)(wrapper);

export default wrappedComponent;
